export enum UserStatus {
  ACTIVE = "active",
  INACTIVE = "inactive",
  DRAFT = "draft",
  REJECTED = "rejected"
}
